import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "../locales/en.json";
import roTranslations from "../locales/ro.json";
import huTranslations from "../locales/hu.json";

// i18n konfiguráció
i18n
  .use(initReactI18next) // React integráció
  .init({
    resources: {
      ro: {
        translation: roTranslations,
      },
      en: {
        translation: enTranslations,
      },
      hu: {
        translation: huTranslations,
      },
    },
    lng: "ro", // alapértelmezett nyelv
    fallbackLng: "ro", // ha nincs lefordítva valami, az angol szöveget használja
    interpolation: {
      escapeValue: false, // React biztonságos karakterek
    },
  });

export default i18n;
